import styled from 'styled-components';
import tw from 'twin.macro';

const Timeline = styled.div(() => [tw` relative z-1`]);

export default Timeline;
